import React, { useCallback, useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';

import styled, { css } from 'styled-components';
import MathContent from '../../../math-content';
import { Container, Badge, Value } from '../';

export const ValidatedContainer = styled(Container)`
    border: 1px solid var(--gray200);
    border-radius: 16px;
    background-color: var(--color-white);
    box-shadow: none;

    cursor: initial;

    ${(props) =>
        props.type === 'error' &&
        css`
            border: 1px solid var(--color-error-default);
            background-color: var(--red50);
        `}

    ${(props) =>
        props.type === 'success' &&
        css`
            border: 1px solid var(--color-success-default);
            background-color: var(--green50);
        `}

    ${(props) =>
        props.type === 'warning' &&
        css`
            border: 1px solid var(--color-warning-default);
            background-color: var(--yellow50);
        `}

    ${(props) =>
        props.type === 'missing' &&
        css`
            border: 1px solid var(--gray700);
            background-color: var(--color-white);
        `}
`;

export const ValidatedBadge = styled(Badge)`
    color: var(--gray800);
    font-size: 16px;
    font-weight: 600;
    letter-spacing: 0px;
    line-height: 24px;
    text-transform: uppercase;

    ${(props) =>
        props.type === 'error' &&
        css`
            background-color: var(--color-error-default);
            color: var(--color-white);
        `}
    ${(props) =>
        props.type === 'success' &&
        css`
            background-color: var(--color-success-default);
            color: var(--color-white);
        `}
    ${(props) =>
        props.type === 'warning' &&
        css`
            background-color: var(--color-warning-default);
            color: var(--color-white);
        `}

        ${(props) =>
        props.type === 'missing' &&
        css`
            background-color: var(--gray700);
            color: var(--color-white);
        `}
`;

const ValidatedChip = ({ badgeIndex, id, type, value, scrolling }) => {
    const ref = useRef(null);
    const [mathRendered, setMathRendered] = useState(false);
    useEffect(() => {
        scrolling && scrolling(ref, mathRendered);
    }, [scrolling, mathRendered]);
    const onRendered = useCallback(() => setMathRendered(true), []);

    return (
        <ValidatedContainer type={type} id={id}>
            <ValidatedBadge type={type}>{badgeIndex}</ValidatedBadge>
            <Value onScroll={() => scrolling(ref)} ref={ref}>
                <MathContent onRendered={onRendered}>{value}</MathContent>
            </Value>
        </ValidatedContainer>
    );
};

ValidatedChip.propTypes = {
    badgeIndex: PropTypes.string,
    id: PropTypes.string,
    scrolling: PropTypes.func,
    type: PropTypes.oneOf(['error', 'success', 'warning', 'missing']),
    value: PropTypes.string,
};

export default ValidatedChip;
